<template>
    <div>
        <router-view/>
    </div>
</template>
<style lang="less">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width:100%;
    height: 100%;
}
.loading-gif{
    height: 100%;
    background: #000;
}
</style>
